import { FC } from 'react'

import * as S from './styled'

const Contact: FC = () => (
  <S.MainWrapper>
    <S.Container>
      <S.Wrapper>
        <S.Content>
          <S.Title>
            <span>09</span> Central de Atendimento
          </S.Title>

          <S.Row>
            <S.MainInfo>
              <h3>Leroy Merlin</h3>
              <h4>(Calm)</h4>
            </S.MainInfo>

            <S.OtherInfos>
              <S.BoxText>
                <p>
                  Em qualquer loja física, durante os horários de funcionamento;
                </p>
              </S.BoxText>

              <S.BoxText $column $width={498}>
                <h4>Por carta para</h4>
                <p>
                  LEROY MERLIN, Rua Pascoal Pais, n. 525, Vila Cordeiro, CEP
                  04581-060, São Paulo – SP
                </p>
              </S.BoxText>

              <S.BoxText $width={450}>
                <p>
                  Pelos telefones 4020-5376 (capitais) e<br />
                  0800-020-5376 (outras regiões), de segunda a sábado, das 8h às
                  22h, e aos domingos, das 9h
                  <br />
                  às 16h;
                </p>
              </S.BoxText>

              <S.BoxText $width={408} $highlight>
                <p>
                  A LEROY MERLIN enviará a confirmação de recebimento. O retorno
                  terá o prazo
                  <br />
                  <strong>máximo de 5 (cinco) dias</strong>.
                </p>
              </S.BoxText>
            </S.OtherInfos>
          </S.Row>
        </S.Content>
      </S.Wrapper>
    </S.Container>

    <S.Footer>
      <S.Center>
        <p>
          Este site é de propriedade, mantido, e operado pela Leroy Merlin
          Companhia Brasileira de Bricolagem (“LEROY MERLIN”)
          <br />
          CNPJ/MF nº 01.438.784/0001-05
          <br />
          Inscrição Estadual nº 298.176.665.115.
          <br />
          Endereço: Rua Pascoal Pais, 525, Andar 6, Vila Cordeiro, CEP 04581-060
        </p>
      </S.Center>
    </S.Footer>
  </S.MainWrapper>
)

export default Contact
